/**
 * `undoable(route, labelKey)` (2.L deliverable 11): the `CallOptions` that offer Undo of the
 * batch a marked route's success names. The client calls `onChangeBatch` once, after a success
 * carrying the header only, so errors and unmarked routes offer nothing.
 */
import type { CallOptions } from '@codex/contracts/client';
import { offerStore } from './store.js';

export function undoable(route: string, labelKey: string = route): CallOptions {
  return {
    onChangeBatch: (batchId) => offerStore.offer({ batchId, labelKey }),
  };
}
